<template>
  <div class="reports-container m-4">
    <div class="reports-group">
      <ul class="reports-items">
        <li
          v-for="report in reports"
          :key="report.url"
          @click="openReportViewer(report, report.displayName)"
          class="border report-item bg-primary text-white p-4"
        >
          {{ report.displayName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ReportViewer from "./ReportViewer.vue";
import reportServer from "../../server/report";

export default {
  name: "ReportsIndex",
  components: {},
  props: ["showing"],
  data: () => ({
    reports: []
  }),
  methods: {
    async fetchReports() {
      this.reports = await reportServer.query();
    },
    openReportViewer(report, text) {
      this.$emit("add-tab", {
        key: report.url,
        text: text,
        component: ReportViewer,
        props: {
          report: report.url,
          isCustom: !report.usesReportEngine
        },
        closeable: true
      });
    }
  },
  watch: {
    showing: function(newValue) {
      if (newValue) {
        this.fetchReports();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.big-icon {
  font-size: 30px;
  line-height: 30px;
  height: 30px;
  margin-top: 4px;
  margin-bottom: 4px;
}
.report-group {
  margin-bottom: 40px;
}
.clear {
  clear: both;
}
.reports-container {
  height: calc(100vh - 238px);
}
.reports-group {
  padding: 1.5rem;
  border-radius: 0.5rem;
  max-height: calc(100% - 140px);
  overflow: auto;

  @media (min-width: 600px) {
    padding: 2rem;
  }
  @media (min-width: 900px) {
    padding: 2rem 2.5rem;
  }
  @media (min-width: 1200px) {
    padding: 2rem 3rem;
  }
}
.reports-items {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem 2.5rem;
}
.report-item {
  border-color: #f5f8fc !important;
  width: 100%;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #c0c0c0 !important;
  }

  @media (min-width: 600px) {
    width: calc(50% - (2.5rem / 2));
  }
  @media (min-width: 900px) {
    width: calc(33.33% - (2.5rem / 1.5));
  }
  @media (min-width: 1200px) {
    width: calc(25% - (2.5rem / 1.33));
  }
}
</style>
